import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default class LockOptions extends BaseRootOption {
  static userInterfaceComponent = data => {
    if (!data) {
      return {
        component: inspectorTools.LIST_VIEW,
      };
    }

    const lockOptions = data["lock-options"] || {};

    return {
      label: "Lock Options",
      component: inspectorTools.LIST_VIEW,
      useVerticalOrientation: true,
      props: {
        modelValue: this.transformToListViewData(lockOptions),
        sideEffect: () => {},
        transformData: this.transformFromListViewData,
      },
    };
  };

  static descriptionMessage = "Options apply to all elements inside this component. Please note elements of the component can override these settings.";

  static defaultValue = {
    isDeletable: true,
    isEditable: true,
    isDraggable: true,
    isDuplicatable: true,
    allowsDrop: true,
    canWrap: true,
    canCreateCustomComponent: true,
  };

  static transformToListViewData(lockOptions) {
    const options = [];
    for (const [key, value] of Object.entries(lockOptions)) {
      options.push({
        id: key,
        label: camelToTitleCase(key),
        editable: false,
        checkable: true,
        active: value,
      });
    }

    return options;
  }

  static transformFromListViewData(listViewData) {
    const options = {};
    listViewData.forEach(updatedListItem => {
      options[updatedListItem.id] = updatedListItem.active;
    });

    return options;
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    const isDeletable = compiledValue.isDeletable ?? true;
    const isEditable = compiledValue.isEditable ?? true;
    const isDraggable = compiledValue.isDraggable ?? true;
    const isDuplicatable = compiledValue.isDuplicatable ?? true;
    const allowsDrop = compiledValue.allowsDrop ?? true;
    const canWrap = compiledValue.canWrap ?? true;
    const canCreateCustomComponent = compiledValue.canCreateCustomComponent ?? true;

    // eslint-disable-next-line
    return `isDeletable: ${isDeletable}, isEditable: ${isEditable}, isDraggable: ${isDraggable}, isDuplicatable: ${isDuplicatable}, allowsDrop: ${allowsDrop}, canWrap: ${canWrap}, canCreateCustomComponent: ${canCreateCustomComponent}`;
  }
}
